import { Grid, InputLabel } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { DatePickerFormField } from 'v2/components/Shared/FormFields/DatePickerFormField';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { Wysiwyg } from 'v2/components/Shared/Wysiwyg';

import type { IForm } from 'v2/components/Shared/Content';

import type { Details as DetailsClass } from '../../classes/General';

interface IProps extends IForm<DetailsClass> {}

function Details(props: IProps) {
  const { setFocus, values, setFieldValue } = props;
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field id='prelaunch' name='prelaunch' label='Agendar lançamento' component={SwitchFormField} />
        </Grid>
        {values.prelaunch && (
          <Fragment>
            <Grid item xs={12}>
              <Field id='launch_date' name='launch_date' label='Data de lançamento' disablePast component={DatePickerFormField} />
            </Grid>
            <Grid item xs={12}>
              <Field
                label='Expectativas de vendas'
                name='sales_expectation'
                id='sales_expectation'
                type='number'
                onFocus={setFocus}
                component={TextFormField}
              />
            </Grid>
          </Fragment>
        )}
        <Grid item xs={12}>
          <Field id='has_expiration_date' name='has_expiration_date' label='O produto tem validade ?' component={SwitchFormField} />
        </Grid>
        {values.has_expiration_date && (
          <Grid item xs={12}>
            <Field id='expiration_date' name='expiration_date' label='Validade do produto' disablePast component={DatePickerFormField} />
          </Grid>
        )}
        <Grid item xs={12}>
          <Field id='email_welcome' name='email_welcome' label='E-mail de acesso' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Url para o produto inativo' name='alternative_url' id='alternative_url' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Nome exibido na fatura do cartão' name='friendly_name' id='friendly_name' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Nome do autor' name='author_name' id='author_name' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <InputLabel style={{ paddingBottom: '0.5rem' }}>O que contém no seu produto</InputLabel>
          <Wysiwyg value={values.program_content} onChange={(v) => setFieldValue('program_content', v)} />
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Details;
